import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'
import {cn} from '~/design-system/utils'

const Collapsible = CollapsiblePrimitive.Root

const CollapsibleTrigger = ({
  ref,
  className,
  children,
  ...props
}: React.ComponentPropsWithRef<typeof CollapsiblePrimitive.Trigger>) => (
  <CollapsiblePrimitive.Trigger
    ref={ref}
    className={cn('group flex flex-1 items-center justify-between', className)}
    {...props}
  >
    {children}
  </CollapsiblePrimitive.Trigger>
)

const CollapsibleContent = ({
  ref,
  className,
  children,
  ...props
}: React.ComponentPropsWithRef<typeof CollapsiblePrimitive.Content>) => (
  <CollapsiblePrimitive.Content ref={ref} className={className} {...props}>
    {children}
  </CollapsiblePrimitive.Content>
)

export {Collapsible, CollapsibleTrigger, CollapsibleContent}
